import { alpha, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  pageWrapper: {
    display: 'grid',
    gap: theme.spacing(3),
  },
  heroCard: {
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  heroTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  heroActions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    alignItems: 'stretch',
  },
  heroActionButton: {
    whiteSpace: 'nowrap',
  },
  banner: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    borderLeft: `4px solid ${theme.palette.info.main}`,
    backgroundColor: theme.palette.grey[100],
  },
  bannerWarning: {
    borderLeftColor: theme.palette.warning.main,
    backgroundColor: alpha(theme.palette.warning.light, 0.5),
  },
  bannerInfo: {
    borderLeftColor: theme.palette.info.main,
    backgroundColor: theme.palette.grey[100],
  },
  tabCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  tabPanel: {
    padding: theme.spacing(3),
  },
  sectionCard: {
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    '& + &': {
      marginTop: theme.spacing(3),
    },
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
  },
  sectionSubtitle: {
    marginBottom: theme.spacing(1.5),
    color: theme.palette.text.secondary,
  },
  formGrid: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  formFullWidth: {
    gridColumn: '1 / -1',
  },
  groupedFields: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: '1fr',
  },
  responseLogForm: {
    marginTop: theme.spacing(2),
  },
  compactSelect: {
    '& .MuiInputBase-root': {
      minHeight: theme.spacing(6),
    },
  },
  checkboxGroup: {
    display: 'grid',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  checkboxGroupLabel: {
    marginBottom: theme.spacing(1),
  },
  checkboxError: {
    marginTop: theme.spacing(1),
  },
  detailGrid: {
    display: 'grid',
    alignItems: 'start',
    gap: theme.spacing(2),
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  detailField: {
    display: 'grid',
    gap: theme.spacing(0.5),
  },
  detailLabel: {
    color: theme.palette.text.secondary,
  },
  detailValue: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  requestTypes: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  requestTypeChip: {
    maxWidth: 160,
  },
  sectionActions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
  },
  resizableTextarea: {
    resize: 'vertical',
    minHeight: theme.spacing(14),
    lineHeight: 1.5,
    whiteSpace: 'pre-wrap',
  },
  logTextarea: {
    resize: 'vertical',
    minHeight: theme.spacing(5),
    lineHeight: 1.5,
    whiteSpace: 'pre-wrap',
  },
  responseLogActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1),
  },
  assetSelectionToolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    margin: theme.spacing(2, 0),
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
  },
  assetSelectionActions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  assetSelectionTableContainer: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    maxHeight: 460,
    '& th': {
      color: theme.palette.text.secondary,
      fontWeight: 600,
      backgroundColor: theme.palette.background.paper,
    },
    '& td': {
      verticalAlign: 'top',
      wordBreak: 'break-word',
    },
  },
  assetSelectionRowSelected: {
    backgroundColor: alpha(theme.palette.primary.light, 0.12),
  },
  helperText: {
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  logList: {
    display: 'grid',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  assetPanel: {
    marginTop: theme.spacing(2),
  },
  accordionContent: {
    display: 'block',
    width: '100%',
  },
  assetPanelHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    alignItems: 'flex-start',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  assetPanelMeta: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.secondary,
  },
  assetPanelBadges: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  requestResultTable: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: theme.spacing(2),
    '& th, & td': {
      textAlign: 'left',
      verticalAlign: 'top',
      padding: theme.spacing(1.5),
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    '& th': {
      color: theme.palette.text.secondary,
      fontWeight: 600,
    },
  },
  summaryGrid: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  summaryPanel: {
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
  },
  summaryHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  summaryDetailsButton: {
    padding: 0,
    border: 0,
    color: theme.palette.primary.main,
    background: 'transparent',
    cursor: 'pointer',
    font: 'inherit',
    fontSize: theme.typography.body2.fontSize,
    whiteSpace: 'nowrap',
  },
  summaryDetails: {
    display: 'grid',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    overflowX: 'auto',
  },
  summaryDetailHeading: {
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  summaryDetailTable: {
    width: '100%',
    minWidth: 520,
    borderCollapse: 'collapse',
    '& th, & td': {
      textAlign: 'left',
      verticalAlign: 'top',
      padding: theme.spacing(0.75, 1),
      borderBottom: `1px solid ${theme.palette.divider}`,
      fontSize: theme.typography.body2.fontSize,
    },
    '& th': {
      color: theme.palette.text.secondary,
      fontWeight: 600,
    },
  },
  summaryDetailsHint: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  retentionBox: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.info.light, 0.2),
    border: `1px solid ${alpha(theme.palette.info.main, 0.25)}`,
  },
  retentionNotice: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.info.main, 0.08),
    borderLeft: `4px solid ${theme.palette.info.main}`,
  },
}));

export default useStyles;
